import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const responseSchema = z.record(
	z.string(),
	z.object({
		uploadRef: z.string(),
		documents: z.array(
			z.object({
				id: z.number(),
				referenceNumber: z.string(),
				documentType: z.number(),
				cdnUrl: z.string(),
				filePath: z.string(),
			})
		),
	})
);

const getDocumentRetrieveAll = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/document/retrieve/all/:encryptedJourneyId',
		method: 'GET',
		responseSchema,
		requestParameters: { encryptedJourneyId: ['required', 'string'] },
		transformResponse(response) {
			const temp: z.infer<typeof responseSchema> = {};

			for (const member of response.data.memberDocuments) {
				temp[member.memberId] = { uploadRef: member.uploadRef, documents: member.documents };
			}

			return temp;
		},
	});

export type GetDocumentRetrieveAllResponse = TypeOfAPIResponse<ReturnType<typeof getDocumentRetrieveAll>>;

export type GetDocumentRetrieveAllError = TypeOfAPIError<ReturnType<typeof getDocumentRetrieveAll>>;

export default getDocumentRetrieveAll;
